import React from 'react'

import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import './styles/variables.css'
import './styles/global.css'
import './styles/common-classes.css'
import './styles/editor.css'
import App from './app/App'
import { store } from './app/store'

const BASENAME_APP = process.env.REACT_APP_BASENAME_APP

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <BrowserRouter basename={BASENAME_APP}>
      <App />
    </BrowserRouter>
  </Provider>
)
